import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminConfig() {
    const [cfg, setCfg] = useState(null);
    const [reports, setReports] = useState([]);

    useEffect(() => {
        api.get("/admin/config").then((r) => setCfg(r.data));
        api.get("/admin/abuse-reports").then((r) => setReports(r.data || []));
    }, []);

    const save = async (e) => {
        e.preventDefault();
        await api.put("/admin/config", cfg);
        toast.success("Configuration saved");
    };

    if (!cfg) return <div className="min-h-screen flex items-center justify-center text-xs font-mono">LOADING…</div>;

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-4xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">ADMIN · CONFIG</p>
                <h1 className="h2 mb-8">Platform configuration</h1>
                <form onSubmit={save} className="card-base p-6 grid sm:grid-cols-2 gap-4 mb-12">
                    {[
                        ["points_per_usd", "Points per USD"],
                        ["min_cashout_points", "Min cashout (points)"],
                        ["points_per_question", "Points per question"],
                        ["min_survey_points", "Min survey (points)"],
                        ["targeting_multiplier", "Targeting multiplier"],
                        ["platform_fee_pct", "Platform fee % (decimal)"],
                    ].map(([k, l]) => (
                        <div key={k}>
                            <label className="eyebrow block mb-2">{l}</label>
                            <input className="input-base" type="number" step="0.01" value={cfg[k]} onChange={(e) => setCfg({ ...cfg, [k]: Number(e.target.value) })} data-testid={`cfg-${k}`} />
                        </div>
                    ))}
                    <div className="sm:col-span-2">
                        <button type="submit" className="btn btn-ink" data-testid="cfg-save-btn">Save configuration</button>
                    </div>
                </form>

                <p className="eyebrow mb-3">ABUSE REPORTS</p>
                <div className="card-base">
                    {reports.length === 0 && <div className="p-8 text-center text-sm text-ink-600">No reports.</div>}
                    {reports.map((r) => (
                        <div key={r.id} className="px-4 py-3 border-b border-ink-200 last:border-b-0 text-sm" data-testid={`report-${r.id}`}>
                            <div className="flex justify-between">
                                <span className="font-mono text-xs">{r.target_type} · {r.target_id}</span>
                                <span className="font-mono text-xs text-ink-600">{new Date(r.created_at).toLocaleString()}</span>
                            </div>
                            <div className="text-ink-600 mt-1">{r.reason}</div>
                            <div className="font-mono text-[10px] mt-1 text-ink-600">STATUS: {r.status.toUpperCase()}</div>
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
